import { useState } from "react";
import { checkDuplicateIDBG } from "../lib/LoginServerCalls";

/**
 * Postoji li to GUI ime na izabranom čvoru — provera na prijavi, pri izlasku
 * iz polja.
 *
 * `serverUrl` se traži izričito. Do 25.09.2026. ga `Login.jsx` nije prosleđivao
 * (`checkDuplicate(idbg)`), pa je zahtev odlazio bez `server_url`, backend ga
 * odbijao sa 400, a `idbgExists` ostajao `undefined` — dakle polje nikad nije
 * pokazalo stanje, a poruka ispod njega nije mogla da se pojavi. Jedini trag je
 * bila greška u konzoli. `Register.jsx` je isto radio ispravno sve vreme.
 */
const useCheckIDBG = (URL) => {
  const [idbgExists, setIdbgExists] = useState();

  const checkDuplicate = async (idbg, serverUrl) => {
    // Adresa čvora stiže sa servera tek posle iscrtavanja, pa je na početku
    // prazna. Slanje bez nje vraća 400 i zatrpava konzolu, a ne saznaje ništa.
    if (!idbg || !serverUrl) return;
    try {
      const result = await checkDuplicateIDBG(URL, idbg, serverUrl);
      setIdbgExists(result);
    } catch (error) {
      console.error("Failed to check IDBG:", error);
    }
  };

  return { idbgExists, checkDuplicate };
};

export default useCheckIDBG;
